import { gql } from "gql";

export const GET_ALL_DYNAMIC_PROCESS_CANDIDATES = gql(/* GraphQL */ `
  query GetAllDynamicProcessCandidates {
    getAllDynamicProcessCandidates {
      id
      caption
      fields {
        name
        caption
        required
      }
    }
  }
`);
